import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractTokenPeriodFilter from "./AbstractTokenPeriodFilter.js";
import OpeningBalanceFormulaNode from "../../formula/OpeningBalanceFormulaNode.js";

/**
 * Period filter used for filtering data on the Opening Balance.
 */
export default class OpeningBalanceTokenPeriodFilter extends AbstractTokenPeriodFilter {
	_formulaNodeConstructor() {
		return OpeningBalanceFormulaNode;
	}

	static getLabel() {
		return _("Opening balance");
	}
}
